<template>
  <div class="info-base">
    <slot />
  </div>
</template>
